import {
  fetchGetMultipleExperiment,
  TGetMultipleExperimentResponse,
} from '../../repositories/ab-use/v1/get-multiple-experiment';
import { TThunkAction } from '../../types/redux';
import { pushExperiments } from './actions';

export function getMultipleExperiment(experimentsNames: string[]): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const response: TGetMultipleExperimentResponse = await fetchGetMultipleExperiment({
        httpApi,
        parameters: {
          experimentsNames,
        },
      });

      if (response.statusCode === 200) {
        dispatch(pushExperiments(response.response.result));

        return;
      }

      logger.warning(response.response.message);
    } catch (err) {
      logger.error('Failed get experiments', err);
    }
  };
}
